<template>
  <div class="event-box">
    <div>
      <div class="cell">
        <div style="background-color: aqua">{{chartData.minor}}</div>
      </div>
      <div class="cell">
        <div style="background-color: gold">{{chartData.major}}</div>
      </div>
    </div>
    <div>
      <div class="cell">
        <div style="background-color: goldenrod">{{chartData.critical}}</div>
      </div>
      <div class="cell">
        <div style="background-color: red">{{chartData.fatal}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EventLevel",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    components: {
    },
    data() {
      return {};
    },
    mounted() {
    }
  };
</script>

<style scoped lang="less">
  .event-box {
    width: 100%;
    height:220px;
    display: flex;
    font-size: 3em;
    flex-flow: column;
    font-family: "lcd";
    color: black;
  }
  .event-box>div {
    width: 100%;
    height:100px;
    display: flex;
    margin: 5px 0;
  }
  .cell>div {
    width: 150px;
    height:100px;
    margin: 0 5px;
    text-align: center;
    vertical-align: middle;
    line-height: 100px;
  }
</style>